/*! @azure/msal-common v15.4.0 2025-03-25 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const cacheQuotaExceededErrorCode = "cache_quota_exceeded";
const cacheUnknownErrorCode = "cache_error_unknown";

export { cacheQuotaExceededErrorCode, cacheUnknownErrorCode };
//# sourceMappingURL=CacheErrorCodes.mjs.map
